/* eslint-disable */
(function ($) {
    const App = {
      MobileServiceMobMenu() {
        $("#mobile-bars").sidr({
          name: "sidr",
          side: "left",
          speed: 400,
          displace: false,
          timing: "ease",
          onOpen() {
            $("#mobile-bars i").removeClass("fa-bars").addClass("fa-times");
            $("body").css({
              position: "fixed",
              width: "100%",
              background: "rgba(0, 0, 0, 0.5)",
            });
            $("#sidr").css("display", "block");
          },
          onClose() {
            $("#mobile-bars i").removeClass("fa-times").addClass("fa-bars");
            $("body").css({
              position: "static",
              width: "auto",
              background: "transparent",
            });
          },
        });
        $("#sidr").css("display", "block");
        $(document).on("click", function (e) {
          if (!$(e.target).closest("#sidr").length) {
            $.sidr("close", "sidr");
          }
        });
  
        /*sidr sub menu*/
        const sidrParentMenu = $("#sidr #mobile-view li.menu-item-has-children");
        const sidrSubmenu = $("#sidr #mobile-view ul.sub-menu");
        const parentAncor = $(
          "#sidr #mobile-view li.menu-item-has-children"
        ).children("a");
  
        $('<i class="fa-solid fa-chevron-down"></i>').appendTo(parentAncor);
        sidrSubmenu.hide();
        sidrParentMenu.children("a").on("click", function (e) {
          e.preventDefault();
          $(this).next("ul.sub-menu").stop().slideToggle();
          $(this).children("i").toggleClass("fa-chevron-down fa-chevron-up");
        });
        $("ul#mobile-view li.menu-item-has-children a").css({
          display: "flex",
          "justify-content": "space-between",
          "align-items": "center",
        });
      },
      MobileServiceVenobox() {
        let venoBox = new VenoBox({
          selector: ".image-popup",
          bgcolor: "#3C92CA",
          numeration: true,
          spinner: "wandering-cubes",
        });
      },
      MobileSlider(){
        var swiper = new Swiper(".mobileSlider", {
          spaceBetween: 30,
          effect: "fade",
          loop: true,
          // autoplay: {
          //   delay: 2500,
          //   disableOnInteraction: false,
          // }
        });
      },
      MobileServiceCarousel() {
        var swiper = new Swiper(".serviceGallery", {
          spaceBetween: 10, 
          loop: true,
          slidesPerView: 1,  
          breakpoints: {
            640: {
              slidesPerView: 2,
            },
            768: {
              slidesPerView: 5,
            }
          },
          // Add autoplay if you want slides to automatically change
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },
        });
      },
      MobilelVenobox() {
        let venoBox = new VenoBox({
          selector: ".image-popup",
          bgcolor: "#3C92CA",
          numeration: true,
          spinner: "wandering-cubes",
        });
      },
      faqAccordion() {
        var allPanels = $(".faq-wrapper .single-faq p").hide();
        var allIcons = $(".faq-wrapper .single-faq .accordion-icon")
          .removeClass("fa-minus")
          .addClass("fa-plus");
  
        $(".faq-wrapper .single-faq h4").click(function () {
          var $this = $(this);
          var $targetPanel = $this.next("p");
          var $icon = $this.find(".accordion-icon");
  
          if ($targetPanel.is(":visible")) {
            $targetPanel.slideUp();
            $icon.removeClass("fa-minus").addClass("fa-plus");
          } else {
            allPanels.slideUp();
            allIcons.removeClass("fa-minus").addClass("fa-plus");
            $targetPanel.slideDown();
            $icon.removeClass("fa-plus").addClass("fa-minus");
          }
          return false;
        });
        // Open the first FAQ item by default
        $(".faq-wrapper .single-faq:first-child p").show();
        $(".faq-wrapper .single-faq:first-child .accordion-icon")
          .removeClass("fa-plus")
          .addClass("fa-minus");
      }
     
    };
  
    App.init = function () {
      App.MobileServiceMobMenu();
      App.MobileSlider();
      App.MobilelVenobox();
      App.MobileServiceCarousel();
    //   App.faqAccordion();
    //   App.eChildrenCarousel();
      // App.stickyHeader();
    };
    $(function () {
      App.init();
    });
  })(jQuery);